<!-- <div>
    <a (click)="selectNode()">{{this.node.name}}</a>
</div> -->

<!-- <div class="css-Item_Categoria-1 item_categoria">
    <li class="css-li_Item-1 li_item">
        <div class="css-Icono_Flecha_Dcha icono_flecha_dcha">
            <img src="assets/images/basecomponents-images/vectors322028944.svg" width="12px" height="12px"
                class="css-Vector_arrow_forward vector_arrowforward">
        </div>
        <a class="css-a_Vinculo-3 a_vinculo" (click)="selectNode()">{{this.node.name}}</a>
    </li>
</div> -->

<!-- 
<div class="css-Item_Peguntas-1 item_peguntas">
    <div class="css-Icono_Punteo icono_punteo">
        <img src="assets/images/basecomponents-images/vectors55001124.svg" width="7px" height="7px"
            class="css-Vector-3 vector">
    </div>
    <a class="css-a_Vinculo-3 a_vinculo" (click)="selectNode()">{{this.node.name}}</a>
</div> -->

<!-- SI NO ES PREGUNTA FRECUENTE -->
<ng-container *ngIf="!esFaq">
  <app-item-categoria
    (evento_click)="selectNode()"
    [(nombre)]="this.node.name"
    [requiereAutenticacion]="requiereAutenticacion"
  ></app-item-categoria>
</ng-container>

<!-- SI ES PREGUNTA FRECUENTE -->
<ng-container *ngIf="esFaq">
  <app-item-pregunta
    (evento_click)="selectNode()"
    [(pregunta)]="this.node.name"
  ></app-item-pregunta>
</ng-container>

<div *ngIf="displayAnswer">
  <span>{{ node.answer }}</span>
</div>
